module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/DAMASK_STEEL_STYLE.57776a20.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/DAMASK_STEEL_STYLE.png
// module id = 1145
// module chunks = 16